import classNames from 'classnames'

import type { LinkType } from 'types'
import Button from 'content-components/_Primatives/Button'
import style from './style.scss'

export type BaseCourseCardType = {
  descriptionText: string
  headerText: string
  link: LinkType
}

type Props = {
  className?: string
} & BaseCourseCardType

function CourseCard(props: Props) {
  const { headerText, className, descriptionText, link } = props
  return (
    <div className={classNames(style.wrapper, className)}>
      <h2 className={style.headline}>{headerText}</h2>
      <p className={style.descriptionText}>{descriptionText}</p>
      <Button
        aria-label={`${link.text} - ${headerText}`}
        className={style.button}
        url={link.url}
        variant='secondaryBlue'
      >
        {link.text}
      </Button>
    </div>
  )
}

export default CourseCard
